import type { ReactNode } from 'react';

export type IncidentListLayoutBoxProps = {
  bannersArea: ReactNode;
  incidentListArea: ReactNode;
  actionBarArea: ReactNode;
  mapArea: ReactNode;
};

export function IncidentListLayoutBox({
  bannersArea,
  incidentListArea,
  actionBarArea,
  mapArea,
}: IncidentListLayoutBoxProps) {
  return (
    <div className="incident-list-layout-box">
      <div className="incident-list-layout-box__banners">{bannersArea}</div>

      <div className="incident-list-layout-box__list">{incidentListArea}</div>

      <div className="incident-list-layout-box__action-bar">{actionBarArea}</div>

      <div className="incident-list-layout-box__map">{mapArea}</div>
    </div>
  );
}
